<div class="ap-floating-action-button" [ngClass]="{ open: open() }" data-testid="fab-wrapper">
    <div class="ap-floating-action-button__container" (transitionend)="transitionEnd()">
        <ap-floating-content-modal
            #modal
            [title]="title()"
            (closeEvent)="openOrClosedModal(floatingActionButtonModel.CLOSED)"
            data-testid="fab-modal"
        >
            <ng-content></ng-content>
        </ap-floating-content-modal>
    </div>
    <button
        #button
        class="ap-floating-action-button__button"
        aria-label="Open chat"
        (click)="openOrClosedModal(floatingActionButtonModel.OPEN)"
        data-testid="fab-button"
    >
        <ap-icon name="conversational-chat" size="extra-large" data-testid="fab-chat-icon"></ap-icon>
    </button>

    @if (badgeNumber()) {
        <div class="ap-floating-action-button__badge" data-testid="fab-badge">
            <ap-badge>{{ badgeNumber() }}</ap-badge>
        </div>
    }
</div>
